import { createContext, useMemo } from "react";
import { themeNamesByGroupId } from "@/theme";
import { getGroupConfig } from "@/pages/signup/config";

export const groupConfigContext = createContext();

const GroupConfigProvider = ({ groupId, children }) => {
  const themeName = themeNamesByGroupId[groupId];
  const config = useMemo(() => getGroupConfig(themeName), [themeName]);
  return (
    <groupConfigContext.Provider value={config}>
      {children}
    </groupConfigContext.Provider>
  );
};

export default GroupConfigProvider;
